// ----------------------------------------------------------------------

export default function TextField(theme) {
  return {
    MuiTextField: {
      defaultProps: {
        variant: 'outlined',
      },
      styleOverrides: {
        root: {
          '& .MuiFormLabel-root': {
            color: theme.palette.text.primary,
          },
        },
      },
    },
  };
}
